import { reflectKeys } from '@/app/shared/services';
import { namespacedPrefix } from '@/app/settings/meals/shared/config';

const gettersTypes = reflectKeys(['LOADING', 'DATA', 'ERROR', 'SELECTED'], namespacedPrefix);

const { LOADING, DATA, ERROR, SELECTED } = gettersTypes;

export { LOADING, DATA, ERROR, SELECTED };
